import BaseModel from '@/shared/models/Category'
import Rule from './Rule'
import axios from '@/plugins/axios'

export default class Category extends BaseModel {
    relationships() {
        return {
            rules: new Rule(),
        }
    }

    async currentCategory() {
        return this.makeFetchRequest(this.resourceUrl() + 'current')
    }

    async getAchievements() {
        let res = await axios.get(`${this.resourceName()}/achievements`)
        if (!res) return null
        return res.data
    }
}
